import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Search, Zap } from "lucide-react";
import { useContent } from "../lib/ContentContext";
import { Phone } from "./PhoneMockup";
import { VoiceOrb } from "./AIMockup";

const Card = ({ to, testid, className = "", children, delay = 0 }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}>
    <Link to={to} data-testid={testid}
      className="group relative flex flex-col h-full rounded-[28px] glass overflow-hidden p-7 lg:p-9 transition-[border-color,transform] duration-500 hover:border-[#d4af37]/60 hover:-translate-y-1">
      {children}
      <span className="absolute top-7 right-7 w-11 h-11 rounded-full border border-white/15 flex items-center justify-center text-white transition-colors duration-300 group-hover:bg-[#d4af37] group-hover:text-black group-hover:border-[#d4af37]">
        <ArrowUpRight className="w-5 h-5" />
      </span>
    </Link>
  </motion.div>
);

const Head = ({ n, p }) => (
  <div className="relative z-10 max-w-[80%]">
    <p className="font-mono text-xs text-[#d9bf6a] tracking-[0.25em]">{n} / PLATFORM</p>
    <h3 className="font-display font-bold text-3xl lg:text-4xl mt-4">{p.name}</h3>
    <p className="text-sm text-slate-300 mt-3 leading-relaxed">{p.category}</p>
  </div>
);

export const PlatformTrio = () => {
  const { content } = useContent();
  const { indril, usb, aios } = content.platforms;
  return (
    <div className="grid gap-5 lg:grid-cols-12 lg:grid-rows-[300px_300px]" data-testid="platform-trio">
      <Card to="/indril" testid="platform-card-indril" className="lg:col-span-7 lg:row-span-2">
        <Head n="01" p={indril} />
        <p className="relative z-10 text-slate-400 text-sm mt-6 max-w-sm hidden sm:block">{indril.description}</p>
        <div className="relative mt-8 lg:mt-0 lg:absolute lg:right-10 lg:bottom-[-140px] flex justify-center transition-transform duration-700 group-hover:-translate-y-4">
          <div className="absolute inset-0 bg-[#0066ff]/30 blur-[90px] rounded-full" />
          <Phone tab="Reels" className="scale-[0.8] origin-top lg:origin-center -mb-24 lg:mb-0" />
        </div>
      </Card>
      <Card to="/urgent-sell-buy" testid="platform-card-usb" className="lg:col-span-5" delay={0.1}>
        <Head n="02" p={usb} />
        <div className="relative mt-6 lg:mt-auto flex flex-col gap-2">
          <span className="field !py-2.5 flex items-center gap-2 text-xs text-slate-400"><Search className="w-4 h-4 text-[#d4af37]" /> Search listings…</span>
          <div className="flex gap-2">
            {["from-[#0b1a3a] to-[#2563eb]", "from-[#3a2a06] to-[#d4af37]", "from-[#06243a] to-[#00b4d8]"].map((g) => (
              <span key={g} className={`flex-1 h-14 rounded-xl bg-gradient-to-br ${g} relative`}><Zap className="absolute top-1.5 left-1.5 w-3 h-3 text-[#f3e5ab]" /></span>
            ))}
          </div>
        </div>
      </Card>
      <Card to="/boss-ai-os" testid="platform-card-aios" className="lg:col-span-5" delay={0.2}>
        <Head n="03" p={aios} />
        <div className="relative flex justify-end -mt-6 lg:absolute lg:right-6 lg:bottom-4 lg:mt-0">
          <VoiceOrb size={120} />
        </div>
      </Card>
    </div>
  );
};
